import { AuthContext } from '../hooks/useAuth'
import { enumFromStringValue } from '../utils/EnumFromStringValue'
import { history, routePrefixCustomer, routePrefixDashboard, routePrefixRedirectLogin } from '../ApplicationRouter'
import { ILinkItem } from '../models/routes/ILinkGroup'
import { IRoute } from '../models/routes/IRoute'
import { Roles } from '../enums/Roles'
import { useContext } from 'react'

export const isArrayWithLength = (arr: string[]) => {
  return Array.isArray(arr) && arr.length;
};

export const GetAllowedRoutes = (routes: IRoute[]) => {
  const tokenContext = useContext(AuthContext);

  // If the current user isn't logged in, and the current path isn't a redirect path
  if (!tokenContext.role && !window.location.pathname.startsWith(routePrefixRedirectLogin)) {
    var pathSplitted = window.location.pathname.split('/')
    // Only check the route if there actually is a route in the location
    if (pathSplitted.length > 0 && pathSplitted[1] !== '') {

      // Check if the path starts with the default dashboad or customer page
      if (`/${pathSplitted[1]}` === routePrefixDashboard || `/${pathSplitted[1]}` === routePrefixCustomer) {
        // history.replace(`${routePrefixRedirectLogin}${window.location.pathname}${window.location.search}`)
        // TODO: redirect when attempting to access a page that requires authentication https://github.com/auxilium/KJE-NFT/issues/45
        history.replace(`${routePrefixRedirectLogin}`)
      }
    }
  }

  // NOTE: all routes without permission are filtered out
  let allowedRoutes = routes.filter((route: IRoute) => {
    if (!route.permission || !isArrayWithLength(route.permission)) {
      return false;
    } else {
      return tokenContext.role && route.permission.indexOf(enumFromStringValue(Roles, tokenContext.role)!) > -1;
    }
  });

  return allowedRoutes;
}

export const GetAllowedLinkRoutes = (routes: ILinkItem[]) => {
  const authContext = useContext(AuthContext);
  const role = authContext.role;

  let allowedRoutes = routes.filter((route: ILinkItem) => {
    if (route.roles !== undefined && isArrayWithLength(route.roles)) {
      return route.roles.indexOf(role as any) > -1
    } else {
      return true;
    }
  })

  return allowedRoutes;
}

/**
 * Function for retrieving the first path element of a route.
 * @returns The first meaningful element of the path, or "".
 */
export const getRouteFirstPath = (route: IRoute): string => {
  if (!route.path) return "";
  let paths = route.path.split("/");
  if (paths[0] !== "") return paths[0];
  else if (paths.length > 0) return paths[1];
  else return "";
}

/**
>>>>>>> development
 * Function for retrieving the first path element of a LinkItem.
 * @returns The first meaningful element of the path, or "".
 */
export const getLinkRoutesFirstPath = (link: ILinkItem): string => {
  let paths = link.href.split("/");
  if (paths[0] !== "") return paths[0];
  else if (paths.length > 0) return paths[1];
  else return "";
}
